import { CommandBase } from "../CommandBase.js";

export class ClearCommand extends CommandBase {
    async execute(args) {
        // Calls the helper method added in Step 1
        this.terminal.clearOutput();
    }
}